'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { noop } from 'lodash';
const Transition = forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const AlertModal = ({ title, message, dismissable = false, action, onClick = noop, maxWidth = 'sm', primaryActionText = 'Ok', secondaryActionText = 'Cancel' }) => {
    const [open, setOpen] = useState(true);
    return (_jsxs(Dialog, { open: open, TransitionComponent: Transition, keepMounted: true, onClose: onClick, fullWidth: true, maxWidth: maxWidth, "aria-describedby": "alert-dialog-slide-description", children: [title && _jsx(DialogTitle, { children: title }), message && (_jsx(DialogContent, { children: _jsx(DialogContentText, { id: "alert-dialog-slide-description", children: message }) })), (dismissable || action) && (_jsxs(DialogActions, { children: [dismissable && _jsx(Button, { onClick: () => setOpen(false), children: secondaryActionText }), _jsx(Button, { onClick: onClick, children: primaryActionText })] }))] }));
};
